import { Paper, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import LightTooltip from 'views/Components/Shared/Components/LightTooltip';

function DetailCard() {
	return (
		<Paper
			sx={{
				width: '350px',
				borderLeft: '5px solid red',
				borderRadius: '0px',
				pl: '5px',
			}}
		>
			<Stack>
				<Typography
					sx={{
						color: 'red',
						fontSize: '14px',
						fontWeight: 600,
						lineHeight: '20px',
						letterSpacing: '0.17px',
						fontFamily: 'Roboto',
					}}
				>
					Error detectado en el Free Shipping
				</Typography>

				<Typography
					sx={{
						color: 'rgba(0, 0, 0, 0.87)',
						fontSize: '14px',
						fontWeight: 400,
						lineHeight: '20px',
						letterSpacing: '0.17px',
						fontFamily: 'Roboto',
					}}
				>
					De acuerdo al baseFreeShipping, el FS debería estar activado
				</Typography>
			</Stack>
		</Paper>
	);
}

export default function ErrorFlagCard({ children }) {
	return (
		<LightTooltip
			title={<DetailCard />}
			placement="top-start"
			customStyles={{
				maxWidth: '350px',
				padding: '0',
			}}
		>
			{children}
		</LightTooltip>
	);
}
